import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../../common/http/http-utils';
@Injectable()

export class Service {
  value = '';
  constructor(public http: HttpClient) {}

  getPVdcs() {
    return this.http
      .get(HttpUtils.getBaseUrl() + '/hybridity/api/providerVdcs')
      .map(
        (res:any) => this.value = res
      );
  }

  getDefaultSizes() {
    return this.http
      .get(HttpUtils.getBaseUrl() + '/hybridity/api/defaultsize')
      .map(
        (res:any) => this.value = res
      );
  }

  getOrgList() {
    return this.http
      .get(HttpUtils.getBaseUrl() + '/hybridity/api/orgs')
      .map(
        (res:any) => this.value = res
      );
  }

  getVDCsList() {
    return this.http
      .get(HttpUtils.getBaseUrl() + '/hybridity/api/vdcNetworks')
      .map(
        (res:any) => this.value = res
      );
  }

  getEditOrgVdc() {
    return this.http
    .get(HttpUtils.getBaseUrl() + '/hybridity/api/virtualdcs')
    .map(
      (res:any) => this.value = res
    );
  }

  getVirtualdc(vdcId) {
    return this.http
    .get(HttpUtils.getBaseUrl() + '/hybridity/api/virtualdc/' + vdcId)
    .map(
      (res:any) => this.value = res
    );
  }

  createOrgVDC(vdcSpec, selectedOrg) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/orgs/' + selectedOrg + '/vdc';
    return this.http
      .post(url, JSON.stringify(vdcSpec))
      .map(
      (res:any) => this.value = res
    );
  }

  updateOrgVDC(vdcSpec, selectedVdcId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/vdc/' + selectedVdcId;
    return this.http
      .put(url, JSON.stringify(vdcSpec))
      .map(
      (res:any) => this.value = res
    );
  }

  editStorageProfiles(orgVdcId, storageProfiles) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/vdc/' + orgVdcId + '/vdcStorageProfiles';
    return this.http
      .post(url, JSON.stringify(storageProfiles))
      .map(
      (res:any) => this.value = res
    );
  }

  logError(error, origin: String = '') {
    console.error('Error: ', error, (origin !== '') ? ' Error from ' + origin : '');
  }

  logOperationCompleted(msg: string) {
    console.log('Operation Completed: ', msg);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/org-vdc-wizard/org-vdc-wizard.service.ts